import React from "react";
import { Button, Theme, styled } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

import { useDispatch } from "react-redux";
import AmplifyAPIWrapper, { INotifications } from "src/API/AmplifyAPIWrapper";

export interface ISendCheckInReminderProps {
  crewId: string;
  pairingId: string;
  style?: any;
}

const OCSendCheckInReminder = styled("div")(({ theme }) => ({
  display: "flex",
  padding: 10,
  flexFlow: "row",
  "& .type_icon": {
    paddingRight: 4,
  },
}));

/**
 * A cell inthe crew check in table to manually send an email reminder to a crew to check in
 * @param props - crew id, pairing id
 */
export const SendCheckInReminder = (props: ISendCheckInReminderProps): JSX.Element => {
  const { crewId, pairingId } = props;
  const dispatch = useDispatch();

  const handleClick = async (event: React.MouseEvent): Promise<void> => {
    event.stopPropagation(); // important when used in the table where rows are clickable.
    if (!crewId || !pairingId) {
      return;
    }

    const notifications: INotifications = {
      dispatch: dispatch,
      infoMessage: "Sending reminder...",
      successMessage: "Successfully sent reminder.",
      errorMessage: "Error: Unable to send reminder.",
    };

    await AmplifyAPIWrapper.Put<any>(`/crew/sendReminder/${pairingId}/${crewId}`, {}, notifications);
  };

  return (
    <OCSendCheckInReminder>
      <Button id={"send_reminder_btn"} variant="outlined" onClick={handleClick} disabled={!pairingId || !crewId}>
        {" "}
        <MailOutlineIcon className="type_icon" />
      </Button>
    </OCSendCheckInReminder>
  );
};
